import './LeadSources.scss'

import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip'
import { show as showModal } from 'redux-modal'
import cx from 'bem-classnames'

import {
  prettyShortNumber
} from 'common/util/helper'


import {
  LEAD_SOURCE_EXPORT_TIMEFRAME, LEAD_SOURCE_HIGH_CUT_OFF, LEAD_SOURCE_LOW_CUT_OFF, PRICE,
  BUYER_TYPE, US_STATES, BROKER_LEAD_STAGES, SHORT_LEAD_TYPE,
} from 'common/constants'

import {
  fetchLeadSourceStats, fetchSlimAccount
} from 'broker/redux/account'

import ProgressCircle from 'common/views/components/ProgressCircle'
import LeadSourceDetailModal from './LeadSourceDetailModal'
import LeadInquiryInfoModal from './LeadInquiryInfoModal'

import { segmentEventTracker } from 'common/analytics'
import { connect } from "react-redux"

const LeadSourceTablet = (props) => {
  const { dispatch } = props

  const ecr = (props.ecr ? props.ecr : 0.0) * 100
  const showEcr = (props.pipeline && props.pipeline['total']) || 0 > 0
  const categorization = showEcr ? (ecr > LEAD_SOURCE_HIGH_CUT_OFF ? 'high' : ecr < LEAD_SOURCE_LOW_CUT_OFF ? 'low' : 'average') : 'none'

  const triangleClasses = {
    name: 'LeadSourceTablet__triangle',
    modifiers: ['high', 'average', 'low', 'none']
  }
  const titleClasses = {
    name: 'LeadSources__modal--header--title',
    modifiers: ['extra-padding']
  }

  const nameKey = props.name_key ? props.name_key : 'other'
  const name = props.name ? props.name : 'Other Sources'
  const logoClasses = ['LeadSourceTablet__title-sec--logo', `LeadSourceTablet__title-sec--logo--${nameKey}`]

  return (
    <div className="LeadSourceTablet" onClick={() => {
      dispatch(showModal('LeadSourceDetailModal', {...props}))

      segmentEventTracker('Modal Shown', {
        'modal_name': 'LeadSourceTablet',
        'lead_source_name': name,
        'lead_source_type_id': props.lead_source_type_id,
        'lead_source_is_confirmed_quality': props.is_confirmed_quality,
        'lead_source_array_placement': props.leadSourceArrayIdx,
        'lead_source_performance_categorization': categorization,
        'lead_source_is_active': props.is_active
      })
    }}>
      <div className={cx(triangleClasses, {[categorization]: true})}/>
      <div className="LeadSourceTablet__title-sec">
        <div className={logoClasses.join(' ')}>
          <div style={{backgroundImage: `url(${props.logo_url})`}}>{!props.logo_url ? <div>OS</div> : null }</div>
        </div>
        <div className="pull-left">
          <div className={cx(titleClasses, {['extra-padding']: !props.is_confirmed_quality})}>{name}</div>
          { props.is_confirmed_quality ? <div className="LeadSourceTablet__title-sec--confirmed"><i className="fa fa-check-circle"/> Confirmed Quality</div> : null }
        </div>
        <div className="LeadSourceTablet__title-sec--activity">
          { !props.is_active ? <div className="LeadSourceTablet__title-sec--inactive"><span>Inactive</span></div> : null }
        </div>
      </div>

      <div className="LeadSourceTablet__content-sec">
        {
          showEcr ? <div>
            <ProgressCircle
              type='lead-sources'
              value={ecr}
              categorization={categorization}
              scaleMin={0}
              scaleMax={LEAD_SOURCE_HIGH_CUT_OFF + 1.5}
            />
            <div className="LeadSourceTablet__content-sec--label">Expected Close Rate <i className="fa fa-question-circle" data-tip="Projections based on Opcity data" /></div>
          </div> : <div>
            <div className="LeadSourceTablet__content-sec--house"/>
            <div className="LeadSourceTablet__content-sec--label--large">No leads referred yet.</div>
            <div className="LeadSourceTablet__content-sec--label--gray">Check back soon.</div>
          </div>
        }

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Leads Received</div>
        <div>
          <div className="LeadSourceTablet__content-sec--data">
            <label>All-Time</label>
            <div className={!props.all_time_summary.lead_count ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{props.all_time_summary.lead_count || '—'}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data">
            <label>Avg Prop. Value</label>
            <div className={!props.all_time_summary.avg_price ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.all_time_summary.avg_price, true)}</div>
          </div>
        </div>

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Transaction Volume</div>
        <div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Closed</label>
            <div className={!props.internal && !props.external ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.internal || 0) + (props.external || 0)}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Volume</label>
            <div className={!props.internal_closes_to_date && !props.external_closes_to_date ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber((props.internal_closes_to_date || 0) + (props.external_closes_to_date || 0) , true)}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Forecast</label>
            <div className={!props.forecast ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.forecast, true)}</div>
          </div>
        </div>

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Earnings</div>
        { props.internal || props.external ? <div className="left-align">
          <div className="LeadSourceTablet__content-sec--data" style={{paddingRight: 22}}>
            <label className="LeadSourceTablet__content-sec--earning-label">Your Referrals</label>

            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Closed</label>
              <div className={!props.internal ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.internal || 0)}</div>
            </div>
            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Commissions</label>
              <div className={!props.internal_commission ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.internal_commission, true)}</div>
            </div>
          </div>
          { props.spilloverEnabled ? <div className="LeadSourceTablet__content-sec--data" style={{paddingLeft: 22, borderLeftWidth: 1, borderLeftColor: '#dddddd', borderLeftStyle: 'solid'}}>
            <label className="LeadSourceTablet__content-sec--earning-label">Network Referrals</label>

            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Closed</label>
              <div className={!props.external ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.external || 0)}</div>
            </div>
            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Payments</label>
              <div className={!props.external_commission ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.external_commission, true)}</div>
            </div>
          </div> : null }
        </div> : <div className="LeadSourceTablet__content-sec--data-empty">
          <div className="LeadSourceTablet__content-sec--money"/><div>This is where you will be able to see your earnings from successfully closed transactions.</div>
        </div> }
      </div>

      <div className="LeadSourceTablet__footer-sec">
        <span>View Details <i className="fa fa-arrow-right"/></span>
      </div>
      <ReactTooltip />
    </div>
  )
}

const FILTER_KEYS = ['source', 'stage', 'market', 'state', 'zipcode', 'likelihood', 'client', 'price', 'agent', 'timeframe']
const FILTER_TYPE_OPTIONS = [
  {value: 'source', label: 'Source Name'},
  {value: 'stage', label: 'Stage'},
  {value: 'market', label: 'Market'},
  {value: 'state', label: 'State'},
  {value: 'zipcode', label: 'Zipcode'},
  {value: 'likelihood', label: 'Client Time Frame'},
  {value: 'client', label: 'Client Category'},
  {value: 'price', label: 'Price Range'},
  {value: 'agent', label: 'Agent Name'},
  {value: 'timeframe', label: 'Time Period'}
]

class LeadSources extends Component {

  constructor(props) {
    super(props)

    this.state = {
      sort: 'created_at',
      sort_direction: 'desc',
      filters: [{filter_type: 'timeframe', filter_value: 'month'}],
      activeFilters: [{filter_type: 'timeframe', filter_value: 'month'}],
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
      exclude_duplicates: true,
      show_inactive: false,
      options: {
        stage: BROKER_LEAD_STAGES,
        likelihood: SHORT_LEAD_TYPE,
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: LEAD_SOURCE_EXPORT_TIMEFRAME,
      }
    }

  }

  componentWillMount() {
    this.props.dispatch(fetchSlimAccount())
      .then(response => {
        if(response.is_partner_brokerage || response.is_transition_brokerage) {
          this.props.dispatch(fetchLeadSourceStats(response.broker_hash))
        }
      })
  }

  renderLeadSource = (leadSource, idx) => {
    return (
      <div className="col-xs-4 LeadSources__tablets--wrapper" key={idx}>
        <LeadSourceTablet {...leadSource} dispatch={this.props.dispatch} spilloverEnabled={this.props.account.spillover_enabled} leadSourceArrayIdx={idx} />
      </div>
    )
  }

  renderLoadingState = () => {
    return (
      <div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
      </div>
    )
  }


  render() {
    const { account={} } = this.props
    const { lead_source_stats } = account

    if (lead_source_stats) {
      Object.keys(lead_source_stats).filter(type_id => {
        lead_source_stats[type_id]['lead_source_type_id'] = type_id
      })
    }

    return <div>
      <div className='LeadSources'>
        { account.feature_flags && !account.feature_flags.hide_lead_source_dashboard ?
          <div className="LeadSources__tablets">
            <div className="LeadSources__tablets--check"><label><input type="checkbox" checked={this.state.show_inactive} onChange={e => this.setState({show_inactive: e.target.checked})}/> Show Inactive</label></div>
            { lead_source_stats ? Object.keys(lead_source_stats)
                .filter(source => (lead_source_stats[source].all_time_summary && lead_source_stats[source].all_time_summary.lead_count && (this.state.show_inactive || lead_source_stats[source].is_active)))
                .sort((a, b) => (lead_source_stats[a].ecr < lead_source_stats[b].ecr))
                .map((key, idx) => this.renderLeadSource(lead_source_stats[key], idx)) : this.renderLoadingState() }
          </div> : null }
      </div>
      <LeadSourceDetailModal {...this.props}/>
      <LeadInquiryInfoModal {...this.props}/>
    </div>
  }
}

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ account: state.account, inquiryModal: state.inquiryModal, auth: state.auth}), mapDispatchToProps)(LeadSources)
